export const appViews = {
  // ── VideoGuides.vue ──
  guides: {
    openCenter: "Guide-Center öffnen",
    fabLabel: "Guides",
    assistantAria: "Guide-Assistent",
    dontShowAgain: "Nicht mehr anzeigen",
    centerAria: "Guide-Center",
    eyebrow: "GUIDE-CENTER",
    title: "WACheckin kennenlernen",
    watchedOf: "{watched} von {total} angesehen",
    close: "Schließen",
    searchPlaceholder: "Guide suchen…",
    forThisScreen: "Für diesen Bildschirm",
    watched: "Angesehen",
    watchGuide: "Guide ansehen",
    comingSoon: "Demnächst: neue Verbesserungen und Updates.",
    noResults: "Keine Ergebnisse für „{query}“.",
    needHelp: "Brauchen Sie Hilfe? ",
    contactWhatsApp: "Schreiben Sie uns auf WhatsApp",
    lightboxMeta: "{section} · Guide {n} von {total}",
    videoTitle: "Guide-Video",
    playerAria: "Guide-Player",
    prev: "Zurück",
    watchOnYouTube: "Auf YouTube ansehen",
    next: "Weiter",
    sections: {
      inicio: "Erste Schritte",
      alojamiento: "Ihre Unterkunft",
      tarifas: "Raten und Kanäle",
      calendario: "Kalender und Buchungen",
      huesped: "Gasterlebnis",
      autoridades: "Behörden",
      novedades: "Neuigkeiten",
    },
    videos: {
      navigate: "Zugang zu den Einstellungen und Navigation",
      propertyData: "Daten, Lage und Branding Ihrer Unterkunft",
      checkinWelcome: "Check-in, Willkommensnachricht und Richtlinien",
      basePrices: "Grundpreise und daraus abgeleitete Kanalraten",
      calendar: "Kalender: Buchungen, Verfügbarkeit und Preise",
      guestJourney: "Die Guest Journey: Nachrichten, Codes und Automatisierungen",
      guestVerification: "Gästeverifizierung und Bewertungsanfragen",
      authorities: "Behörden verbinden und Reisendenmeldungen senden",
    },
    ai: {
      cta: "Videoliste ansehen",
      assistant: "Assistent",
      inicio: "Erster Tag hier? Ich zeige Ihnen die Grundlagen in 2 Minuten.",
      alojamiento: "Richten Sie Ihre Unterkunft ein? Sehen Sie, wie sie perfekt wird.",
      tarifas: "Fragen zu Preisen? Ich erkläre Ihnen die Raten je Kanal.",
      calendario: "Möchten Sie den Kalender meistern? Buchungen, Preise und Verfügbarkeit.",
      huesped: "Automatisieren wir die Guest Journey? Ich zeige es Ihnen Schritt für Schritt.",
      autoridades: "Verbinden wir die Behörden? Reisendenmeldungen in 1 Video.",
    },
  },
  // ── NovedadesDrawer.vue ──
  news: {
    ariaPanel: "Systemneuigkeiten",
    latestUpdates: "Neueste Updates",
    close: "Schließen",
    tabNews: "Neuigkeiten",
    reports: "Meldungen",
    loading: "Wird geladen…",
    emptyNews: "Noch keine Neuigkeiten. Sie sehen Verbesserungen hier, sobald wir sie veröffentlichen.",
    showMore: "Mehr anzeigen",
    showLess: "Weniger anzeigen",
    reportProblem: "Problem melden",
    emptyReports: "Sie haben noch keine Meldungen gesendet.",
    sendReport: "+ Meldung senden",
    sendNewReport: "+ Neue Meldung senden",
    capturesCount: "{count} Screenshot | {count} Screenshots",
    viewConversation: "Gespräch ansehen →",
    new: "Neu",
    openedOn: "eröffnet am {date}",
    conversationWithSupport: "Gespräch mit dem Support-Team",
    you: "Sie",
    support: "Support",
    noReplyYet: "Noch hat niemand aus dem Team geantwortet. Wir sagen Ihnen hier Bescheid, sobald es so weit ist.",
    replyPlaceholder: "Schreiben Sie Ihre Antwort…",
    send: "Senden",
    replyHint: "<b>Enter</b> sendet · <b>Shift + Enter</b> neue Zeile",
    back: "Zurück",
    sendReportTitle: "Meldung senden",
    formSubtitle: "Sagen Sie uns, was passiert ist, und wir sehen es uns an. Die Antwort finden Sie in Ihren Meldungen.",
    about: "Betrifft",
    whatHappens: "Was ist passiert?",
    titlePlaceholder: "Fassen Sie es in einem Satz zusammen",
    describeDetail: "Beschreiben Sie es im Detail",
    descPlaceholder: "Was Sie erwartet haben, was passiert ist und wie man es nachstellt.",
    capture: "Screenshot",
    optional: "optional",
    attachHint: "Tippen, um ein Bild anzuhängen",
    sending: "Wird gesendet…",
    submitReport: "Meldung senden",
    prev: "Zurück",
    next: "Weiter",
    today: "Heute",
    yesterday: "Gestern",
    status: {
      open: "Offen",
      in_progress: "In Bearbeitung",
      resolved: "Gelöst",
      closed: "Geschlossen",
    },
    errRequired: "Sagen Sie uns, was passiert ist.",
    errSend: "Senden nicht möglich. Bitte versuchen Sie es erneut.",
  },
  // ── VerifyIdentity.vue ──
  verify: {
    title: "Identitätsprüfung",
    subtitle: "Um Ihren Check-in abzuschließen, müssen wir Ihre Identität prüfen",
    idDocument: "Ausweisdokument",
    idDocumentDesc: "Machen Sie ein scharfes Foto der Vorderseite Ihres Dokuments (Personalausweis, NIE, ID-Karte, Reisepass oder Führerschein)",
    selfie: "Selfie",
    selfieDesc: "Machen Sie ein Selfie, auf dem Ihr Gesicht klar zu sehen ist",
    requirements: "Anforderungen:",
    req1: "Gute Beleuchtung",
    req2: "Ganzes Dokument im Rahmen",
    req3: "Lesbarer Text",
    req4: "Selfie ohne Accessoires, die Ihr Gesicht verdecken",
    start: "Prüfung starten",
    frontTitle: "Vorderseite des Dokuments",
    alignDocument: "Richten Sie Ihr Dokument im Rahmen aus",
    hintLegible: "Achten Sie darauf, dass alle Angaben lesbar sind",
    faceTitle: "Gesichtsprüfung",
    alignFace: "Richten Sie Ihr Gesicht im Kreis aus",
    hintLookCamera: "Schauen Sie ohne Accessoires direkt in die Kamera",
    reviewTitle: "Fotos prüfen",
    reviewSubtitle: "Prüfen Sie, ob alle Bilder scharf und lesbar sind",
    frontDocTitle: "Vorderseite des Dokuments",
    retake: "Neu aufnehmen",
    back: "Zurück",
    submit: "Zur Prüfung senden",
    processingTitle: "Ihre Identität wird geprüft",
    processingDesc: "Wir prüfen Ihre Dokumente. Das kann einige Sekunden dauern...",
    dontClose: "Schließen Sie dieses Fenster nicht",
    successTitle: "Prüfung erfolgreich!",
    successDesc: "Ihre Identität wurde erfolgreich bestätigt.",
    continue: "Weiter",
    errorTitle: "Fehler bei der Prüfung",
    couldNotVerify: "Wir konnten Ihre Identität nicht bestätigen. Bitte versuchen Sie es erneut.",
    retry: "Erneut versuchen",
    cameraErrorTitle: "Kein Zugriff auf die Kamera",
    cameraErrorDesc: "Wir konnten nicht auf Ihre Kamera zugreifen. Bitte prüfen Sie die Berechtigungen und versuchen Sie es erneut.",
    suggestions: "Vorschläge:",
    tip1: "Prüfen Sie, ob Sie die Kameraberechtigung erteilt haben",
    tip2: "Prüfen Sie, ob keine andere App die Kamera nutzt",
    tip3: "Starten Sie Ihren Browser neu, wenn das Problem bestehen bleibt",
    tryAgainCamera: "Erneut versuchen",
    couldNotVerifyShort: "Wir konnten Ihre Identität nicht bestätigen",
    serverError: "Serverfehler",
    tryLater: "Bitte versuchen Sie es später erneut",
  },
};
